export class BFGameEvent {
    public static readonly ENTER_FREESPIN: string = 'Enter_FreeSpin_Mode';
    public static readonly EXIT_FREESPIN: string = "Exit_FreeSpin_Mode";
    public static readonly ON_WIN_ANIM_START: string = "On_Win_Anim_Start";
    public static readonly ON_WIN_ANIM_STOP: string = "On_Win_Anim_Stop";
    public static readonly STOP_WILD_FIRE_ANIM: string = "Stop_Wild_Fire_Anim";
    public static readonly STOP_SCATTER_FIRE_ANIM: string = "Stop_Scatter_Fire_Anim";
    public static readonly STOP_SCATEER_ANIMAITON_ON_REEL: string = "STOP_SCATEER_ANIMAITON_ON_REEL";
    public static readonly UPDATE_MULTIPLIER_BG: string = "Update_Multiplier_Bg";
    public static readonly SHOW_X1_MULTIPLIER: string = "Show_x1_Multiplier_On_Wild_Sym";
    public static readonly TOGGLE_MH_INNER_FIRE: string = "Toggle_Multiplier_Holder_Inner_Fire_Animation";
    public static readonly HIDE_WILD_FIRE: string = "Hide_wild_fire";
}